//  For each product on the page
document.querySelectorAll('.productV3').forEach(section => {
    let product = JSON.parse(section.querySelector(".productV3OptionItemValuesLabelInput.type:checked").value);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Product Swipers
     ************/
    section.querySelectorAll('.productV3VisualWrap').forEach(item => {
        let productSwiper = new Swiper(item.querySelector(".productV3VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: item.querySelector(".productV3VisualSwiperNext"),
                prevEl: item.querySelector(".productV3VisualSwiperPrev"),
            },
            on: {
                slideChange: function () {
                    if (!item.querySelector(".productV3VisualSwiperSlide")) {
                        return;
                    }
                    // update the thumbnail active class
                    item.querySelector(".productV3VisualThumbsSlide.active").classList.remove("active");
                    item.querySelectorAll(".productV3VisualThumbsSlide")[this.realIndex].classList.add("active");

                }
            }
        });

        // change slide on thumbnail click
        item.querySelectorAll(".productV3VisualThumbsSlide").forEach(element => {
            element.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });

    })


    // update active variant on input changes
    section.querySelectorAll(".productV3 input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/
    async function updateProduct() {

        // variables to check if elements exist
        let productATCExists = section.querySelector(".productV3ATC") || false;

        // get the selected product
        product = JSON.parse(section.querySelector(".productV3OptionItemValuesLabelInput.type:checked").value);


        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            let optionContainer = section.querySelector('.productV3Options')

            // collect options from inputs
            let options = [];
            optionContainer.querySelectorAll(`.productV3OptionItem.allowed`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV3ATC").disabled = true;
            section.querySelector(".productV3ATC").textContent = "Not Available";

            section.querySelector('.productV3GiftFormSubmit').classList.add('disabled');
            section.querySelector('.productV3GiftFormSubmit').textContent = 'Not Available';
            section.querySelector(".productV3ATC").classList.remove('oos');

            return;
        }

        /**************
         Active Swiper
         ***************/
            // We map the product and color to a specific gallery
            // clogs black -> #clogs-black
            // clogs white -> #clogs-white
            // slides black -> #slides-black
            // slides white -> #slides-white
        let galleryMap = {
                Clogs: {
                    Black: "clogs-black",
                    White: "clogs-white"
                },
                Slides: {
                    Black: "slides-black",
                    White: "slides-white"
                }
            };

        let productName = product.title.includes("Clog") ? "Clogs" : "Slides";
        let color = activeVariant.option1.includes("Black") ? "Black" : "White";
        let galleryName = galleryMap[productName][color];

        section.querySelectorAll('.productV3VisualWrap').forEach(item =>
            item.classList.toggle("active", item.id === galleryName)
        );


        let iconMap = {
            Clogs: {
                Black: "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/image_3_339c99fe-96d3-4243-ae96-9360c0497e76.png?v=1760397014&width=500",
                White: "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/Render.bip.1681_d2c3befd-4cef-4a7d-b217-e3af07d0151f.png?v=1764094893&width=500"
            },
            Slides: {
                Black: "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/2025_C3_Render_recovery_CLOG.1667_2.png?v=1760397119&width=500",
                White: "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/2025_C3_Render_recovery_CLOG.1666_25369c37-7037-40e7-9b11-e205618c3330.png?v=1764094893&width=500"
            }
        };
        // update type selector images
        section.querySelector('.productV3OptionItemValuesLabelBodyIcon.clogs').src = iconMap["Clogs"][color];
        section.querySelector('.productV3OptionItemValuesLabelBodyIcon.slides').src = iconMap["Slides"][color];

        // update text
        let title = product.title.replace("VKTRY", "");
        // remove trailing s
        if (title.endsWith("s")) {
            title = title.slice(0, -1);
        }
        section.querySelector('.productV3OptionItemControlsTitleVal.type').textContent = title;
        section.querySelector('.productV3OptionItemControlsTitleVal.color').textContent = activeVariant.option1;


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV3ATC").disabled = false;

            // let total = activeVariant.price
            //
            //
            // // check for additional products
            // section.querySelectorAll('.productV3FormPair.active').forEach(item => {
            //     let variant = JSON.parse(item.getAttribute("variant"));
            //     if (variant) {
            //         total += variant.price
            //     }
            // })

            section.querySelector(".productV3ATC").innerHTML = `Add To Cart`;
            section.querySelector(".productV3ATC").classList.remove('oos');
            section.querySelector('.productV3GiftFormSubmit').classList.remove('disabled');
            section.querySelector('.productV3GiftFormSubmit').textContent = 'SUBMIT';

            section.querySelector('.productV3Additional').classList.add('active');

        } else {
            section.querySelector(".productV3ATC").classList.add('oos');
            section.querySelector(".productV3ATC").textContent = "Notify When Available";
            section.querySelector('.productV3GiftFormSubmit').classList.add('disabled');
            section.querySelector('.productV3GiftFormSubmit').textContent = 'Sold Out';
            section.querySelector('.productV3Additional').classList.remove('active');

        }

        // check if any pairs are active
        if (section.querySelectorAll(".productV3FormPair.active").length === 0) {
            section.querySelector('.productV3FormPairs').classList.remove('active');
            section.querySelectorAll(".productFormOptionSlideLabel.active").forEach(element => element.classList.remove("active"));
        } else {
            section.querySelector('.productV3FormPairs').classList.add('active');

        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image on page load
    updateProduct();

    /**************
     Product Pairs
     ***************/

    // open edit
    section.querySelectorAll(".productV3FormPairEdit").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = this.closest(".productV3FormPair");

            // save option element
            let variant = pairElement.getAttribute("variant");

            // open modal
            pairElement.querySelector(".productV3FormPairModal").showModal();

            // select options
            let variantParsed = JSON.parse(variant);

            // auto select options
            let color = variantParsed["option1"];
            let size = variantParsed["option3"];
            let gender = variantParsed["option2"];
            let prod = JSON.parse(pairElement.getAttribute("product"))
            let handle = prod.handle;

            // gender
            pairElement.querySelectorAll('.productV3FormPairModalLabelSelect[name="option-Gender"] option').forEach(option => {
                if (option.value === gender) {
                    option.selected = true;
                }
            })

            // size
            pairElement.querySelectorAll('.productV3FormPairModalLabelSelect[name="option-Size"] option').forEach(option => {
                if (option.value === size) {
                    option.selected = true;
                }
            })

            // color
            pairElement.querySelector(`.productV3OptionItemValuesLabelInput.color[value='${color}']`).checked = true;

            // type (Clogs/Slides)
            pairElement.querySelector(`.productV3OptionItemValuesLabelInput.type[data-handle='${handle}']`).checked = true;


            // update text
            pairElement.querySelector('.productV3OptionItemControlsTitleVal.type').textContent = prod.title.replace("VKTRY", "");
            pairElement.querySelector('.productV3OptionItemControlsTitleVal.color').textContent = variantParsed.option1;

            // reset button
            pairElement.querySelector(".productV3FormPairModalUpdate").disabled = true;
            pairElement.querySelector(".productV3FormPairModalUpdate").textContent = "Add to Order";

        })
    });

    // close event
    section.querySelectorAll(".productV3FormPairModal").forEach(element => {
        element.addEventListener('close', function () {

            // save pair element
            let pairElement = this.closest(".productV3FormPair");

            // check if this input has no options, then we hide it (it means they added a product with different options and canclled)
            if (!pairElement.getAttribute("variant")) {
                pairElement.classList.remove("active");
            }
            updateProduct()

        });
    })

    // trigger close modal
    section.querySelectorAll(".productV3FormPairModal,.productV3FormPairModalCancel,.productV3FormPairModalExit").forEach(element => {
        element.addEventListener("click", function (e) {
            if (e.target === this) {
                section.querySelector(".productV3FormPairModal[open]").close();
            }
        })
    });

    // form input events
    section.querySelectorAll(".productV3FormPairModalLabelSelect").forEach(element => element.addEventListener("change", function () {
        // check if the entire form is ready
        let form = this.closest(".productV3FormPairModalContent");

        // check if all inputs are entered
        let ready = true;
        form.querySelectorAll(".productV3FormPairModalLabelSelect").forEach(input => {
            if (input.selectedIndex === 0) {
                ready = false;
            }
        });


        // update variant and product attributes
        let formElement = this.closest(".productV3FormPairModalContent");
        let prod = JSON.parse(formElement.querySelector('.productV3OptionItemValuesLabelInput.type:checked').value);
        let variant = {};

        // collect options from inputs
        let options = [];
        formElement.querySelectorAll(`.productV3OptionItem.allowed`).forEach(group => {
            options.push(group.querySelector(`input:checked`).value);
        });

        // collect options from selects
        formElement.querySelectorAll(`.productV3FormPairModalLabelSelect`).forEach(select => {
            options.push(select.value);
        })

        // find new variant based on the options
        variant = prod.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });

        if (!variant) {
            ready = false;
            form.querySelector(".productV3FormPairModalUpdate").textContent = "Not Available";
            return
        }

        // check if variant is available
        if (!variant.available) {
            ready = false;
            form.querySelector(".productV3FormPairModalUpdate").textContent = "Sold out";
        }

        // update text
        form.querySelector('.productV3OptionItemControlsTitleVal.type').textContent = prod.title.replace("VKTRY", "");
        form.querySelector('.productV3OptionItemControlsTitleVal.color').textContent = variant.option1;

        // update update button
        form.querySelector(".productV3FormPairModalUpdate").disabled = !ready;
        if (ready) {
            form.querySelector(".productV3FormPairModalUpdate").textContent = "Add to Order";
        }
    }));

    // enable update button if color or type radio is changed
    section.querySelectorAll(".productV3FormPairModalContent").forEach(element => {
        element.querySelectorAll('.productV3OptionItemValuesLabelInput').forEach(input => {
            input.addEventListener("change", function () {
                let ready = true;
                let prod = JSON.parse(element.querySelector('.productV3OptionItemValuesLabelInput.type:checked').value);
                let variant = {};

                // collect options from inputs
                let options = [];
                element.querySelectorAll(`.productV3OptionItem.allowed`).forEach(group => {
                    options.push(group.querySelector(`input:checked`).value);
                });

                // collect options from selects
                element.querySelectorAll(`.productV3FormPairModalLabelSelect`).forEach(select => {
                    options.push(select.value);
                })

                // find new variant based on the options
                variant = prod.variants.find((variant) => {
                    return JSON.stringify(variant.options) === JSON.stringify(options)
                });

                if (!variant) {
                    ready = false;
                    element.querySelector(".productV3FormPairModalUpdate").textContent = "Not Available";

                    return;
                }

                // check if variant is available
                if (!variant.available) {
                    ready = false;
                    element.querySelector(".productV3FormPairModalUpdate").textContent = "Sold out";
                }

                // update text
                element.querySelector('.productV3OptionItemControlsTitleVal.type').textContent = prod.title.replace("VKTRY", "");
                element.querySelector('.productV3OptionItemControlsTitleVal.color').textContent = variant.option1;


                // update update button
                element.querySelector(".productV3FormPairModalUpdate").disabled = !ready;
                if (ready) {
                    element.querySelector(".productV3FormPairModalUpdate").textContent = "Add to Order";
                }
            });
        })

    });


    // update pair
    section.querySelectorAll(".productV3FormPairModalContent").forEach(element => {
        element.addEventListener("submit", function (e) {
            e.preventDefault();

            // save pair element
            let pairElement = this.closest(".productV3FormPair");

            // set this option as active
            pairElement.classList.add("active");

            // update variant and product attributes
            let prod = JSON.parse(pairElement.querySelector('.productV3OptionItemValuesLabelInput.type:checked').value);
            let variant = {};

            // collect options from inputs
            let options = [];
            element.querySelectorAll(`.productV3OptionItem.allowed`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // collect options from selects
            element.querySelectorAll(`.productV3FormPairModalLabelSelect`).forEach(select => {
                options.push(select.value);
            })

            // find new variant based on the options
            variant = prod.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });

            pairElement.setAttribute("variant", JSON.stringify(variant));
            pairElement.setAttribute("product", JSON.stringify(prod));

            // close modal
            section.querySelector(".productV3FormPairModal[open]").close();

            updateProduct();
        });
    });

    // remove
    section.querySelectorAll(".productV3FormPairRemove").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = this.closest(".productV3FormPair");

            // remove active and options
            pairElement.classList.remove("active");
            pairElement.removeAttribute("variant");
            pairElement.removeAttribute("product");


            // update product
            updateProduct();
        });
    })

    // same as first
    section.querySelector(".productV3FormActionSame").addEventListener("click", function () {
        // check for a free slot
        let nextFree = section.querySelector(".productV3FormPair:not(.active)");
        if (nextFree) {
            nextFree.classList.add("active");
            nextFree.setAttribute("variant", JSON.stringify(activeVariant));
            nextFree.setAttribute("product", JSON.stringify(product));
        }
        updateProduct();
    });

    // new pair
    section.querySelector(".productV3FormActionNew").addEventListener("click", function () {
        //check for a free slot
        let nextFree = section.querySelector(".productV3FormPair:not(.active)");
        if (nextFree) {
            nextFree.classList.add("active");
            nextFree.querySelector(".productV3FormPairModal").showModal();
            section.querySelector('.productV3FormPairs').classList.add('active');
        }
    });


    /**************
     Product Sizes
     ***************/
    // listen for size button click
    document.querySelectorAll('.productV3OptionItemControlsCountriesItem').forEach(element => {
        element.addEventListener("click", function () {
            // remove active class from all buttons
            document.querySelectorAll('.productV3OptionItemControlsCountriesItem').forEach(item => {
                item.classList.remove("active");
            });
            element.classList.add("active");


            // show the selected size
            let target = element.dataset.target;
            document.querySelectorAll(`.productV3OptionItemValuesLabelBodySizes`).forEach(item => {
                item.classList.remove("active");
                if (item.classList.contains(target)) {
                    item.classList.add("active");
                }
            });


        });

    });

    /**************
     Product ATC
     ***************/
    section.querySelector('.productV3ATC').addEventListener("click", async function () {

        // check OOS
        if (this.classList.contains("oos")) {

            // Klaviyo OOS
            Swal.fire({
                title: `Notify Me When Available`,
                input: "email",
                inputPlaceholder: "Email",
                showCancelButton: true,
                confirmButtonText: "Notify Me",
                cancelButtonText: "Cancel",
                showLoaderOnConfirm: true,
                customClass: {
                    container: 'oos'
                },
                preConfirm: async () => {
                    let email = Swal.getInput().value;
                    await sendKlaviyoBackInStockRequest(email, parseInt(activeVariant.id));
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                // if the user confirmed the skip, show success message and reload the page
                if (result.isConfirmed) {
                    Swal.fire({
                        title: `Success`,
                        text: `We'll notify you when the product is back in stock.`,
                        icon: "success"
                    })
                }
            });

            return;
        }


        // add loading animation
        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for additional products
        section.querySelectorAll('.productV3FormPair.active').forEach(item => {
            let variant = JSON.parse(item.getAttribute("variant"));
            if (variant) {
                formData.items.push({
                    quantity: 1,
                    id: variant.id,
                });
            }
        })

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open upsell
        await openUpsell();

        // open cart
        await openCart();
    });


    // Submit gift form
    section.querySelector('.productV3GiftFormSubmit').addEventListener('click', async function (e) {
        e.preventDefault();

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // create url params
        const giftParams = new URLSearchParams({
            fromName: document.querySelector(".productV3GiftFormName").value,
            handle: product.handle,
            formData: JSON.stringify(formData)
        }).toString();

        // send event to Klaviyo
        const response = await fetch(`https://api.vktry.com/send-a-gift.php`, {
            method: "POST",
            body: new URLSearchParams({
                fromName: document.querySelector(".productV3GiftFormName").value,
                toEmail: document.querySelector(".productV3GiftFormEmail").value,
                purchaseURL: `https://${window.location.hostname}/pages/send-gift-clogs?${giftParams}`,
            })
        })
            .then(response => response.json())

        // check for error
        if (response.error) {
            await Swal.fire({
                title: 'Error',
                text: response.error,
            });
            return;
        }

        // update text
        section.querySelector(".productV3GiftTxt").textContent = "Your email was sent with the VKTRYs you would like as a gift.";
        section.querySelector('.productV3GiftForm').classList.remove('active');
    });


    // setup Dropdowns
    section.querySelectorAll(".productV3InfoDropTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Gorgias chat
     ***************/
    section.querySelector('.productV3Chat')?.addEventListener('click', function () {
        // open gorgias chat
        if (GorgiasChat) {
            GorgiasChat.open()
        }

    })

    // get reviews count
    fetch(`https://api.okendo.io/v1/stores/a23ff890-5779-4aad-a3bc-dd0fdde26942/products/shopify-14619269136751/review_aggregate`)
        .then(response => response.json())
        .then(data => {
            // calculate average rating
            const totalReviews = data.reviewAggregate.ratingAndReviewCount;

            // insert average rating
            //AR=1∗a+2∗b+3∗c+4∗d+5∗e/(R)
            //where a,b,c,d,e are the number of reviews with rating 1,2,3,4,5 respectively and R is the total number of reviews
            let level1Count = data.reviewAggregate.ratingAndReviewCountByLevel.level1Count || 0;
            let level2Count = data.reviewAggregate.ratingAndReviewCountByLevel.level2Count || 0;
            let level3Count = data.reviewAggregate.ratingAndReviewCountByLevel.level3Count || 0;
            let level4Count = data.reviewAggregate.ratingAndReviewCountByLevel.level4Count || 0;
            let level5Count = data.reviewAggregate.ratingAndReviewCountByLevel.level5Count || 0;

            const averageRating = (1 * level1Count + 2 * level2Count + 3 * level3Count + 4 * level4Count + 5 * level5Count) / totalReviews;
            const averageRatingRounded = Math.round(averageRating * 10) / 10;


            // update label
            section.querySelectorAll(".productV3FormReviewsTxtLink").forEach(element => {
                element.textContent = `${totalReviews}+ reviews`;
            });

            section.querySelectorAll(".productV3FormReviewsTxtAvg").forEach(element => {
                element.textContent = `${averageRatingRounded}`;
            });

        })
});


/**************
 Product Upsells
 ***************/

// upsell swiper
let upsellSwiper = new Swiper('.upsellSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.upsellSwiperFooterPag',
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
});

// store the swiper slides to use for later
let socksSlide = document.querySelector('#upsellSocks');
let boostsSlide = document.querySelector('#upsellBoosts');
let gripsSlide = document.querySelector('#upsellGrips');
let clogsSlide = document.querySelector('#upsellClogs');
let silverSlide = document.querySelector('#upsellSilver');
let bagSlide = document.querySelector('#upsellBag');
let silverProduct = JSON.parse(document.querySelector('#upsellSilver').dataset.product)
let tag = '';

// add to cart event listeners
document.querySelectorAll(".upsellCheckout").forEach(element => {
    element.addEventListener("click", async function () {

        // Used in Discount Kit to target specific upsell products
        let discountProperty = '';

        // start loading
        this.classList.add("loading");

        // determine the first insole gender and size
        const gender = document.querySelector('.productV3OptionItemValuesLabelInput.gender:checked').value;
        const size = document.querySelector('.productV3OptionItemValuesLabelInput.size:checked').value;

        // determine the variant id
        let variantID;
        let available = true;

        if (element.classList.contains("boosts")) {
            discountProperty = 'boosts_upsell';
            tag = 'boost upsell';
            if ((gender === "Male" && isSizeInRange(size, 0, 9)) || (gender === "Female" && isSizeInRange(size, 0, 10.5))) {
                variantID = 42757218402475; // medium
            } else {
                variantID = 42757218435243; // large
            }
        } else if (element.classList.contains("silver")) {
            discountProperty = 'silver_upsell';
            tag = 'silver upsell';

            // find the silver variant based on the selected input from silver and clogs
            let silverWeight = document.querySelector('#upsellSilver').querySelector('.upsellLabelInput:checked').value;
            let variant = silverProduct.variants.filter(variant => {
                let silverSize = variant.options[0].split('-')[1];
                return variant.options[2] === gender && silverSize === size.split('-')[1] && variant.options[1] === weightToTopCover[silverWeight];
            })
            variantID = variant[0].id;

        } else if (element.classList.contains("clogs")) {

            discountProperty = 'clog_upsell';
            tag = 'clog upsell';

            // find the variant based on the selected input
            let color = document.querySelector('.upsellSwiperSlideControlsLabelInput:checked').value;
            let clogProduct = JSON.parse(element.dataset.productV3);

            let clogOptions = [];

            const insoleColorToClogColor = {
                "Black": "Carbon Black",
                "White": "Cloud White",
            }

            // add color, size, gender
            clogOptions.push(insoleColorToClogColor[color]);
            clogOptions.push(gender);

            // map half sizes down to full size
            // 3 -> 3, 3.5 -> 3
            clogOptions.push(parseInt(size).toString());

            // find new variant based on the options
            let clogVariant = clogProduct.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(clogOptions)
            });

            if (clogVariant.available) {
                variantID = clogVariant.id;
            } else {
                available = false;
            }
        } else if (element.classList.contains("grips")) {
            tag = 'grips upsell';
            discountProperty = 'grip_socks_upsell';
            if ((gender === "Male" && isSizeInRange(size, 0, 8)) || (gender === "Female" && isSizeInRange(size, 0, 11))) {
                variantID = 52140728320367 // medium
            } else if ((gender === "Male" && isSizeInRange(size, 0, 12)) || (gender === "Female" && isSizeInRange(size, 0, 13))) {
                variantID = 52140728353135; // large
            } else {
                variantID = 52140728385903; // xlarge
            }
        } else if (element.classList.contains("bag")) {
            tag = 'drawstring bag upsell';

            discountProperty = 'drawstring_bag_upsell';
            variantID = 51675503427951
        } else if (element.classList.contains("silver")) {
            discountProperty = 'silver_upsell';
            variantID = 51675503427951
        } else {
            // compression socks
            discountProperty = 'compression_socks_upsell';
            tag = 'compression socks upsell';

            if ((gender === "Male" && isSizeInRange(size, 0, 7)) || (gender === "Female" && isSizeInRange(size, 0, 9))) {
                variantID = 42970044924075 // medium
            } else if ((gender === "Male" && isSizeInRange(size, 0, 12)) || (gender === "Female" && isSizeInRange(size, 0, 14))) {
                variantID = 42970045382827; // large
            } else {
                variantID = 42970045415595; // xlarge
            }
        }

        // if this has already been added, remove it from the cart
        if (this.classList.contains("added")) {
            let cart = await getCart();

            // find the item
            let item = cart.items.find(item => item.variant_id === variantID);

            // if there is no item, return
            if (!item) {
                this.textContent = "Add to Cart";
                this.classList.remove("loading");
                return;
            }

            await changeProduct({
                id: item.key,
                quantity: item.quantity - 1
            });

            this.classList.remove("added");
            this.textContent = "Add to Cart";
            this.classList.remove("loading");
            return;
        }


        // add
        if (available) {
            await addProduct({
                quantity: 1,
                id: variantID,
                properties: {
                    _upsell_tag: tag,
                    _upsell: true,
                    _discount_kit: discountProperty
                }
            });
        }

        // stop loading
        this.classList.remove("loading");

        element.textContent = "Remove";
        this.classList.add("added");


        // if all upsells have been added, close
        if (document.querySelectorAll(".upsellCheckout.added").length === document.querySelectorAll(".upsellCheckout").length) {
            this.closest(".upsell").close();
        }

        // if there is a next slide, slide to it
        if (this.closest(".swiper-slide").nextElementSibling) {
            upsellSwiper.slideNext();
        }
    });
});


// delete the hidden upsells from the DOM
document.querySelector('.hiddenUpsells').remove();

// controls
document.querySelector('.upsellContentControl.prev').addEventListener('click', function () {
    upsellSwiper.slidePrev();
});

document.querySelector('.upsellContentControl.next').addEventListener('click', function () {
    upsellSwiper.slideNext();
});


function isSizeInRange(currentSize, min, max) {
    const range = currentSize.split('-').map(parseFloat);
    const size = parseFloat(range[0]);
    return !isNaN(size) && size >= min && size <= max;
}

// top cover is based of weight (SILVER INSOLES)
let weightToTopCover = {
    "70 - 99lbs": "L",
    "100 - 120lbs": "L",
    "121 - 150lbs": "L",
    "151 - 180lbs": "H",
    "181 - 210lbs": "H",
    "211 - 230lbs": "H",
    "231 - 260lbs": "H",
    "261lbs - Up": "H"
};

function updateUpsell() {
    let silverUpsellEl = document.querySelector('#upsellSilver');


    // map sizes from clog to silver
    let clogSize = parseInt(document.querySelector('.productV3OptionItemValuesLabelInput.size:checked').value);
    let clogGender = document.querySelector('.productV3OptionItemValuesLabelInput.gender:checked').value;
    let silverWeight = silverUpsellEl.querySelector('.upsellLabelInput:checked').value;


    let variant = silverProduct.variants.filter(variant => {
        let silverSize = parseInt(variant.options[0].split('-')[1]);
        return variant.options[2] === clogGender && silverSize === clogSize && variant.options[1] === weightToTopCover[silverWeight];
    })

    // no variant found
    if (variant.length === 0) {
        silverUpsellEl.querySelector('.upsellCheckout').disabled = true;
        silverUpsellEl.querySelector('.upsellCheckout').textContent = "Not Available";
        return;
    }
    silverUpsell = variant[0];

    // unavailable variant
    if (!silverUpsell.available) {
        silverUpsellEl.querySelector('.upsellCheckout').disabled = true;
        silverUpsellEl.querySelector('.upsellCheckout').textContent = "Sold Out";
        return;
    }

    silverUpsellEl.querySelector('.upsellCheckout').disabled = false;
    silverUpsellEl.querySelector('.upsellCheckout').textContent = "Add To Cart";
}


// open ankle upsell
async function openUpsell() {

    // update swiper controls
    document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.remove("active"));
    document.querySelector('.upsellSwiperFooter').classList.remove("active");

    document.querySelectorAll('.upsellContentControl').forEach(element => element.classList.add("active"));
    document.querySelector('.upsellSwiperFooter').classList.add("active");


    // remove all swiper slides
    upsellSwiper.removeAllSlides();

    // Add slides
    // check if there are any possible silver variants for the upsell based on their choices for the clogs
    let clogSize = parseInt(document.querySelector('.productV3OptionItemValuesLabelInput.size:checked').value);
    let clogGender = document.querySelector('.productV3OptionItemValuesLabelInput.gender:checked').value;
    let possibleSilverVariants = silverProduct.variants.filter(variant => {
        let silverSize = parseInt(variant.options[0].split('-')[1]);
        return variant.options[2] === clogGender && silverSize === clogSize;
    })
    if (possibleSilverVariants.length > 0) {
        // add silver slide if there are any possible silver variants
        upsellSwiper.appendSlide(silverSlide);

        // listen for silver upsell input change (weight)
        document.querySelectorAll('.upsellLabelInput')?.forEach(element => {
            element.addEventListener("change", function () {
                updateUpsell();
            });
        })
    }
    upsellSwiper.appendSlide(socksSlide);
    upsellSwiper.appendSlide(bagSlide);


    // open the upsell
    document.querySelector(`#upsell`).showModal();

    document.querySelector("body").classList.add("noScroll");


    // wait for modal to be closed
    await new Promise((resolve, reject) => {
        document.querySelector(`#upsell`).addEventListener("close", function (e) {
            resolve('closed');
        });
    });
}

// close events
document.querySelectorAll(".upsell").forEach(element => {
    // exist backdrop
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            this.close();
            document.querySelector("body").classList.remove("noScroll");

        }
    })
});

// close upsell via button
document.querySelectorAll(".upsellClose").forEach(element => {
    element.addEventListener("click", function () {
        this.closest(".upsell").close();
        document.querySelector("body").classList.remove("noScroll");
    });
});


// register dialog
dialogPolyfill.registerDialog(document.querySelector("#upsell"));


/**************
 Shoe size
 ***************/

// open shoe size modal
document.querySelectorAll(".openShoeSize").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('#shoeSizeClog').showModal();
        document.querySelector("body").classList.add("noScroll");
    })
});

//close shoe size event listener
document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
    element.addEventListener("click", async function () {
        let target = this.dataset.target;
        await closeSize(target);
        // open back up modal once the shoe size modal is closed
        if (lastOpenedModal) {
            lastOpenedModal.showModal();
        }
        preventSubmit = false;

    });
});


//close shoe size event listener
document.querySelectorAll(".shoeSize")?.forEach(function (element) {
    element.addEventListener("click", async function (e) {
        if (e.target === this) {
            let target = element.id;
            await closeSize(target);

            // open back up modal once the shoe size modal is closed
            if (lastOpenedModal) {
                lastOpenedModal.showModal();
            }

            preventSubmit = false;
        }
    });
});

// close shoe size
function closeSize(target) {
    document.querySelector(`#${target}`).close();
    document.querySelector("body").classList.remove("noScroll");
}

// register dialogs
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});

/**************
 Money Back
 ***************/

// open moneyBack dialog
document.querySelectorAll('.openMoneyBack').forEach(function (element) {
    element.addEventListener('click', function () {
        document.querySelector("#moneyBack").showModal();
        document.querySelector("body").classList.add("noScroll");
    });
})

// close moneyBack
function closePopup() {
    document.querySelector("#moneyBack").close();
    document.querySelector("body").classList.remove("noScroll");
}

// close moneyBack event listener
document.querySelectorAll(".moneyBackClose").forEach(function (element) {
    element.addEventListener("click", closePopup);
});

document.querySelector("#moneyBack").addEventListener("click", function (e) {
    if (e.target === this) {
        closePopup();
    }
})

// close event
document.querySelector("#moneyBack").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));
